import React from 'react';
import SEO from '../../components/SEO';
import {
  Hero, QuickAccess, SacredPlaces, PlanPilgrimage, MoreServices,
  WhyChooseUs, Numbers, TravelPromo, Testimonials, AppNewsletter,
} from '../../components/Home';

const SITE = 'https://ayodhyadham.info';

const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE}/#website`,
      url: SITE,
      name: 'AyodhyaDham.info',
      description: 'Guide to Ayodhya — Ram Mandir darshan, temples and ghats, e-puja, stays and trip planning.',
      inLanguage: ['en-IN', 'hi-IN', 'gu-IN', 'mr-IN'],
      publisher: { '@id': `${SITE}/#organization` },
      potentialAction: {
        '@type': 'SearchAction',
        target: { '@type': 'EntryPoint', urlTemplate: `${SITE}/temples?q={search_term_string}` },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE}/#organization`,
      name: 'AyodhyaDham.info',
      url: SITE,
      logo: { '@type': 'ImageObject', url: `${SITE}/images/logo-small.png` },
      image: `${SITE}/images/og-default.jpg`,
      description: 'An independent travel and pilgrimage guide to Ayodhya, Uttar Pradesh.',
      email: 'contact@ayodhyadham.info',
      areaServed: { '@type': 'City', name: 'Ayodhya' },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        email: 'contact@ayodhyadham.info',
        availableLanguage: ['English', 'Hindi', 'Gujarati', 'Marathi'],
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Ayodhya',
        addressRegion: 'Uttar Pradesh',
        postalCode: '224123',
        addressCountry: 'IN',
      },
      sameAs: [],
    },
    {
      '@type': 'TouristDestination',
      '@id': `${SITE}/#destination`,
      name: 'Ayodhya',
      description: 'One of the seven Moksha-puris of Hinduism and the birthplace of Lord Shri Ram, on the banks of the Saryu river in Uttar Pradesh, India.',
      url: `${SITE}/about`,
      touristType: ['Pilgrims', 'Cultural tourists', 'History enthusiasts'],
      geo: { '@type': 'GeoCoordinates', latitude: 26.7922, longitude: 82.1998 },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Ayodhya',
        addressRegion: 'Uttar Pradesh',
        addressCountry: 'IN',
      },
      includesAttraction: [
        { '@type': 'TouristAttraction', name: 'Shri Ram Janmabhoomi Mandir', url: `${SITE}/temples` },
        { '@type': 'TouristAttraction', name: 'Hanuman Garhi', url: `${SITE}/temples` },
        { '@type': 'TouristAttraction', name: 'Kanak Bhawan', url: `${SITE}/temples` },
        { '@type': 'TouristAttraction', name: 'Ram ki Paidi', url: `${SITE}/ghats` },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEO
        title="Experience the Divine Ayodhya"
        description="Book darshan at Shri Ram Mandir, explore sacred temples and ghats, sponsor a puja, find verified stays and plan your yatra to Ayodhya."
        keywords="Ayodhya pilgrimage, Ram Mandir darshan, Ayodhya travel guide, Ayodhya hotels, e-puja booking, darshan booking"
        canonicalUrl="/"
        structuredData={structuredData}
      />

      <Hero />
      <QuickAccess />

      <section className="section home-main">
        <div className="container home-main__grid">
          <div className="home-main__primary"><SacredPlaces /></div>
          <div className="home-main__aside"><PlanPilgrimage /></div>
        </div>
      </section>

      <section className="section--tight">
        <div className="container home-three">
          <MoreServices />
          <div className="home-three__stack"><WhyChooseUs /><Numbers /></div>
          <TravelPromo />
        </div>
      </section>

      <section className="section">
        <div className="container"><Testimonials /></div>
      </section>

      <section className="section--tight">
        <div className="container"><AppNewsletter /></div>
      </section>
    </>
  );
}
